var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTechnologiesOutlined(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/cpu"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cpu"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.76967 3.76967C4.87914 2.6602 6.52603 2.25 8.6 2.25H13.4C15.474 2.25 17.1209 2.6602 18.2303 3.76967C19.3398 4.87914 19.75 6.52603 19.75 8.6V13.4C19.75 15.474 19.3398 17.1209 18.2303 18.2303C17.1209 19.3398 15.474 19.75 13.4 19.75H8.6C6.52603 19.75 4.87914 19.3398 3.76967 18.2303C2.6602 17.1209 2.25 15.474 2.25 13.4V8.6C2.25 6.52603 2.6602 4.87914 3.76967 3.76967ZM4.83033 4.83033C4.1398 5.52086 3.75 6.67397 3.75 8.6V13.4C3.75 15.326 4.1398 16.4791 4.83033 17.1697C5.52086 17.8602 6.67397 18.25 8.6 18.25H13.4C15.326 18.25 16.4791 17.8602 17.1697 17.1697C17.8602 16.4791 18.25 15.326 18.25 13.4V8.6C18.25 6.67397 17.8602 5.52086 17.1697 4.83033C16.4791 4.1398 15.326 3.75 13.4 3.75H8.6C6.67397 3.75 5.52086 4.1398 4.83033 4.83033Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28217 6.28217C7.05414 5.5102 8.17603 5.25 9.5 5.25H12.5C13.824 5.25 14.9459 5.5102 15.7178 6.28217C16.4898 7.05414 16.75 8.17603 16.75 9.5V12.5C16.75 13.824 16.4898 14.9459 15.7178 15.7178C14.9459 16.4898 13.824 16.75 12.5 16.75H9.5C8.17603 16.75 7.05414 16.4898 6.28217 15.7178C5.5102 14.9459 5.25 13.824 5.25 12.5V9.5C5.25 8.17603 5.5102 7.05414 6.28217 6.28217ZM7.34283 7.34283C6.9898 7.69586 6.75 8.32397 6.75 9.5V12.5C6.75 13.676 6.9898 14.3041 7.34283 14.6572C7.69586 15.0102 8.32397 15.25 9.5 15.25H12.5C13.676 15.25 14.3041 15.0102 14.6572 14.6572C15.0102 14.3041 15.25 13.676 15.25 12.5V9.5C15.25 8.32397 15.0102 7.69586 14.6572 7.34283C14.3041 6.9898 13.676 6.75 12.5 6.75H9.5C8.32397 6.75 7.69586 6.9898 7.34283 7.34283Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.01001 0.25C7.42422 0.25 7.76001 0.585786 7.76001 1V3C7.76001 3.41421 7.42422 3.75 7.01001 3.75C6.5958 3.75 6.26001 3.41421 6.26001 3V1C6.26001 0.585786 6.5958 0.25 7.01001 0.25Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 0.25C11.4142 0.25 11.75 0.585786 11.75 1V3C11.75 3.41421 11.4142 3.75 11 3.75C10.5858 3.75 10.25 3.41421 10.25 3V1C10.25 0.585786 10.5858 0.25 11 0.25Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0.25C15.4142 0.25 15.75 0.585786 15.75 1V3C15.75 3.41421 15.4142 3.75 15 3.75C14.5858 3.75 14.25 3.41421 14.25 3V1C14.25 0.585786 14.5858 0.25 15 0.25Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.25 7C18.25 6.58579 18.5858 6.25 19 6.25H21C21.4142 6.25 21.75 6.58579 21.75 7C21.75 7.41421 21.4142 7.75 21 7.75H19C18.5858 7.75 18.25 7.41421 18.25 7Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.25 11C18.25 10.5858 18.5858 10.25 19 10.25H21C21.4142 10.25 21.75 10.5858 21.75 11C21.75 11.4142 21.4142 11.75 21 11.75H19C18.5858 11.75 18.25 11.4142 18.25 11Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.25 15C18.25 14.5858 18.5858 14.25 19 14.25H21C21.4142 14.25 21.75 14.5858 21.75 15C21.75 15.4142 21.4142 15.75 21 15.75H19C18.5858 15.75 18.25 15.4142 18.25 15Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 18.25C15.4142 18.25 15.75 18.5858 15.75 19V21C15.75 21.4142 15.4142 21.75 15 21.75C14.5858 21.75 14.25 21.4142 14.25 21V19C14.25 18.5858 14.5858 18.25 15 18.25Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.01 18.25C11.4242 18.25 11.76 18.5858 11.76 19V21C11.76 21.4142 11.4242 21.75 11.01 21.75C10.5958 21.75 10.26 21.4142 10.26 21V19C10.26 18.5858 10.5958 18.25 11.01 18.25Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.01001 18.25C7.42422 18.25 7.76001 18.5858 7.76001 19V21C7.76001 21.4142 7.42422 21.75 7.01001 21.75C6.5958 21.75 6.26001 21.4142 6.26001 21V19C6.26001 18.5858 6.5958 18.25 7.01001 18.25Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 7C0.25 6.58579 0.585786 6.25 1 6.25H3C3.41421 6.25 3.75 6.58579 3.75 7C3.75 7.41421 3.41421 7.75 3 7.75H1C0.585786 7.75 0.25 7.41421 0.25 7Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 11C0.25 10.5858 0.585786 10.25 1 10.25H3C3.41421 10.25 3.75 10.5858 3.75 11C3.75 11.4142 3.41421 11.75 3 11.75H1C0.585786 11.75 0.25 11.4142 0.25 11Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 15C0.25 14.5858 0.585786 14.25 1 14.25H3C3.41421 14.25 3.75 14.5858 3.75 15C3.75 15.4142 3.41421 15.75 3 15.75H1C0.585786 15.75 0.25 15.4142 0.25 15Z",
    fill: "#7C7C7C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnologiesOutlined);
export default __webpack_public_path__ + "static/media/technologiesOutlined.c32e31c3246e0b3cd51388a535e12a8c.svg";
export { ForwardRef as ReactComponent };